import Header from './Header';
import Hero from './Hero';
import ScrollingBanner from './ScrollingBanner';
import FeaturedVideo from './FeaturedVideo';
import CaseStudies from './CaseStudies';
import Stats from './Stats';
import Services from './Services';
import TaxStrategies from './TaxStrategies';
import VideoGrid from './VideoGrid';
import TopYouTubeVideos from './TopYouTubeVideos';
import TaxFreeRetireeExperts from './TaxFreeRetireeExperts';
import Contact from './Contact';
import Footer from './Footer';

const AppLayout = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <ScrollingBanner />
        <section id="home">
          <Hero />
        </section>
        <FeaturedVideo />
        <Stats />
        <section id="services">
          <Services />
        </section>
        <CaseStudies />
        <TaxStrategies />
        <section id="appearances">
          <VideoGrid />
        </section>
        <TopYouTubeVideos />
        <TaxFreeRetireeExperts />
        <section id="contact">
          <Contact />
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default AppLayout;